<template>

  <v-container fluid class="local-auth-login">
    <v-row class="pa-0 ma-0" no-gutters align="center" justify="center">
      <v-col cols="3">Email</v-col>
      <v-col cols="9" class="pl-4 pr-6">
        <v-text-field v-model="activeUsername" />
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0" no-gutters align="center" justify="center">
      <v-col cols="3">Password</v-col>
      <v-col cols="9" class="pl-4 pr-6">
        <v-text-field type="password" v-model="activePassword" @keyup.enter="performLogin" />
      </v-col>
    </v-row>

    <v-row class="mt-1">
      <v-col cols="12" class="d-flex align-center justify-center">
        <v-btn
            width="140"
            color="primary"
            @click="performLogin">
          Login
        </v-btn>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'LocalAuthLogin',

  data () {
    return {
      activeUsername: this.username,
      activePassword: this.password
    }
  },

  props: {
    username: {
      type: String,
      default: ''
    },
    password: {
      type: String,
      default: ''
    }
  },

  methods: {
    performLogin () {
      this.$emit('login', { username: this.activeUsername, password: this.activePassword })
    }
  }
}
</script>

<style scoped>
</style>
